export const INSIGHTS_HEADER_ACTIONS_ID = 'insights-header-actions';
